import { Injectable } from '@angular/core';
import { BehaviorSubject, asyncScheduler, distinctUntilChanged, observeOn } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private inFlightCount = 0;
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);

  // Emit async to avoid ExpressionChangedAfterItHasBeenCheckedError when requests start mid-CD.
  readonly loading$ = this.loadingSubject.asObservable().pipe(
    distinctUntilChanged(),
    observeOn(asyncScheduler)
  );

  start(): void {
    this.inFlightCount += 1;
    if (this.inFlightCount === 1) {
      this.loadingSubject.next(true);
    }
  }

  stop(): void {
    if (this.inFlightCount > 0) {
      this.inFlightCount -= 1;
    }
    if (this.inFlightCount === 0) {
      this.loadingSubject.next(false);
    }
  }

  clear(): void {
    this.inFlightCount = 0;
    this.loadingSubject.next(false);
  }
}
